/**
 * Simple Product Card - Material Swatch Handler
 *
 * Used by the simple-prd-card snippet (Best Sellers etc.). The preset catalogs
 * (Lab Diamond, Moissanite) hold Material as a VARIANT OPTION — the handle has
 * no material to swap and there is no custom.material metafield — so the old
 * "guess a sibling handle" approach did nothing. Instead each product carries
 * exactly one image per metal (…-WG_…, …-YG_…, …-RG_… in the filename), so a
 * swatch click fetches the product by its own handle and swaps the card image
 * to the clicked metal's image. Mirrors updateProductImages in
 * material-swatch-handler.js (which handles the .main-prd-card grid cards).
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
      var swatchBlock = e.target.closest('.spc-prd-swatch-block');
      if (!swatchBlock) return;
      var card = swatchBlock.closest('.simple-prd-card');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      handleSwatchClick(swatchBlock, card);
    });
  });

  function handleSwatchClick(swatchBlock, card) {
    if (swatchBlock.classList.contains('spc-prd-swatch-block-ac')) return;

    // Visual feedback immediately
    setActiveSwatch(card, swatchBlock);

    var handle = swatchBlock.getAttribute('data-product-handle');
    // data-material-value is the variant option value ("14k White Gold").
    // Fall back to the legacy slug attribute just in case.
    var targetMaterial = swatchBlock.getAttribute('data-material-value')
      || swatchBlock.getAttribute('data-material');
    var token = metalTokenOf(targetMaterial);
    if (!handle || !token) {
      return;
    }

    setLoading(card, true);
    fetchMetalImage(handle, token, card);
  }

  function setActiveSwatch(card, clickedSwatch) {
    card.querySelectorAll('.spc-prd-swatch-block').forEach(function (block) {
      block.classList.remove('spc-prd-swatch-block-ac');
    });
    clickedSwatch.classList.add('spc-prd-swatch-block-ac');
  }

  // Metal token as it appears in the image filename (…-WG_…, …-YG_…, …-RG_…).
  function metalTokenOf(material) {
    var m = (material || '').toLowerCase();
    if (m.indexOf('white') > -1) return 'WG';
    if (m.indexOf('yellow') > -1) return 'YG';
    if (m.indexOf('rose') > -1) return 'RG';
    return null;
  }
  function imageMatchesMetal(url, token) {
    return new RegExp('-' + token + '[_-]', 'i').test(url || '');
  }

  function setLoading(card, on) {
    var img = card.querySelector('.spc-product-img');
    if (img) {
      img.style.transition = 'opacity 0.3s ease';
      img.style.opacity = on ? '0.5' : '1';
    }
  }

  function fetchMetalImage(handle, token, card) {
    var query = [
      'query ProductImages($handle: String!) {',
      '  product(handle: $handle) {',
      '    images(first: 50) { nodes { url altText } }',
      '  }',
      '}',
    ].join('\n');

    fetch('/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': window.ShopifyStorefrontToken || 'e539f71b63c693b67ec76376ee4e9ddd',
      },
      body: JSON.stringify({ query: query, variables: { handle: handle } }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var product = data && data.data && data.data.product;
        var nodes = (product && product.images && product.images.nodes) || [];
        var match = nodes.filter(function (n) { return imageMatchesMetal(n.url, token); })[0];
        if (match) {
          swapImage(card, match.url, match.altText);
        } else {
          setLoading(card, false);
        }
      })
      .catch(function () { setLoading(card, false); });
  }

  function swapImage(card, url, altText) {
    var img = card.querySelector('.spc-product-img');
    if (!img) return;
    var reveal = function () { img.style.opacity = '1'; img.onload = null; };
    img.style.opacity = '0';
    img.onload = reveal;
    img.src = url;
    if (altText) img.alt = altText;
    // Safety net: a cached image may not fire onload.
    setTimeout(reveal, 400);
  }

  // Kept for any external callers.
  window.SimpleCardSwatchHandler = {
    handleSwatchClick: handleSwatchClick,
    updateActiveSwatch: setActiveSwatch,
  };
})();
